<template>
  <ams-table
    :heading="heading"
    :ams_api_path="ams_api_path"
    :ams_type="ams_type"
    :ams_fields="ams_fields"
    :describe_belongs_to="describe_belongs_to"
  />
</template>

<script>
import AmsTable from './AmsTable.vue'

export default {
  components: {
    AmsTable
  },
  data() {
    return {
      heading: 'Collections',
      ams_type: 'collections',
      ams_api_path: 'api/admin/v1',
      ams_fields: [
       { 
          key: 'attributes.name',
          label: 'Name',
          sortable: true,
          filterable: true,
          class: 'text-left',
          sortDirection: 'asc' 
        },
       { 
          key: 'attributes.access-permission',
          label: 'Access Permission',
          sortable: true,
          filterable: true,
          class: 'text-center',
          sortDirection: 'asc' 
        },
      ],
      describe_belongs_to: [
        {
          prepend: '',
          type: 'interests',
          description_attr: 'name',
          append: ' '
        },
      ]
    }
  }
}
</script>